/* eslint-disable */
//@ts-nocheck
// source: freeform_v2.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var freeform_v1_pb = require('./freeform_v1_pb.js');
goog.object.extend(proto, freeform_v1_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.freeform.AffineTransform', null, global);
goog.exportSymbol('proto.freeform.BubbleV2', null, global);
goog.exportSymbol('proto.freeform.ColorV2', null, global);
goog.exportSymbol('proto.freeform.ImageContentV2', null, global);
goog.exportSymbol('proto.freeform.ObjectMetadataV2', null, global);
goog.exportSymbol('proto.freeform.ObjectType', null, global);
goog.exportSymbol('proto.freeform.ObjectV2', null, global);
goog.exportSymbol('proto.freeform.ObjectV2.ContentCase', null, global);
goog.exportSymbol('proto.freeform.Size', null, global);
goog.exportSymbol('proto.freeform.TextContentV2', null, global);
goog.exportSymbol('proto.freeform.TextRunV2', null, global);
goog.exportSymbol('proto.freeform.TextStyleV2', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.ObjectV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.freeform.ObjectV2.oneofGroups_);
};
goog.inherits(proto.freeform.ObjectV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.ObjectV2.displayName = 'proto.freeform.ObjectV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.Size = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.freeform.Size, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.Size.displayName = 'proto.freeform.Size';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.AffineTransform = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.freeform.AffineTransform, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.AffineTransform.displayName = 'proto.freeform.AffineTransform';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.ObjectMetadataV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.freeform.ObjectMetadataV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.ObjectMetadataV2.displayName = 'proto.freeform.ObjectMetadataV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.ImageContentV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.freeform.ImageContentV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.ImageContentV2.displayName = 'proto.freeform.ImageContentV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.TextContentV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.freeform.TextContentV2.repeatedFields_, null);
};
goog.inherits(proto.freeform.TextContentV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.TextContentV2.displayName = 'proto.freeform.TextContentV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.BubbleV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.freeform.BubbleV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.BubbleV2.displayName = 'proto.freeform.BubbleV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.TextRunV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.freeform.TextRunV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.TextRunV2.displayName = 'proto.freeform.TextRunV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.TextStyleV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.freeform.TextStyleV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.TextStyleV2.displayName = 'proto.freeform.TextStyleV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.ColorV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.freeform.ColorV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.ColorV2.displayName = 'proto.freeform.ColorV2';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.freeform.ObjectV2.oneofGroups_ = [[4,5,100]];

/**
 * @enum {number}
 */
proto.freeform.ObjectV2.ContentCase = {
  CONTENT_NOT_SET: 0,
  TEXT: 4,
  IMAGE: 5,
  OLD_TEXT: 100
};

/**
 * @return {proto.freeform.ObjectV2.ContentCase}
 */
proto.freeform.ObjectV2.prototype.getContentCase = function() {
  return /** @type {proto.freeform.ObjectV2.ContentCase} */(jspb.Message.computeOneofCase(this, proto.freeform.ObjectV2.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.ObjectV2.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.ObjectV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.ObjectV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.ObjectV2.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadata: (f = msg.getMetadata()) && proto.freeform.ObjectMetadataV2.toObject(includeInstance, f),
    size: (f = msg.getSize()) && proto.freeform.Size.toObject(includeInstance, f),
    transform: (f = msg.getTransform()) && proto.freeform.AffineTransform.toObject(includeInstance, f),
    text: (f = msg.getText()) && proto.freeform.TextContentV2.toObject(includeInstance, f),
    image: (f = msg.getImage()) && proto.freeform.ImageContentV2.toObject(includeInstance, f),
    oldText: (f = msg.getOldText()) && freeform_v1_pb.FFText.toObject(includeInstance, f),
    deprecatedSenderTag: jspb.Message.getBooleanFieldWithDefault(msg, 101, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.ObjectV2}
 */
proto.freeform.ObjectV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.ObjectV2;
  return proto.freeform.ObjectV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.ObjectV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.ObjectV2}
 */
proto.freeform.ObjectV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.freeform.ObjectMetadataV2;
      reader.readMessage(value,proto.freeform.ObjectMetadataV2.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = new proto.freeform.Size;
      reader.readMessage(value,proto.freeform.Size.deserializeBinaryFromReader);
      msg.setSize(value);
      break;
    case 3:
      var value = new proto.freeform.AffineTransform;
      reader.readMessage(value,proto.freeform.AffineTransform.deserializeBinaryFromReader);
      msg.setTransform(value);
      break;
    case 4:
      var value = new proto.freeform.TextContentV2;
      reader.readMessage(value,proto.freeform.TextContentV2.deserializeBinaryFromReader);
      msg.setText(value);
      break;
    case 5:
      var value = new proto.freeform.ImageContentV2;
      reader.readMessage(value,proto.freeform.ImageContentV2.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    case 100:
      var value = new freeform_v1_pb.FFText;
      reader.readMessage(value,freeform_v1_pb.FFText.deserializeBinaryFromReader);
      msg.setOldText(value);
      break;
    case 101:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeprecatedSenderTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.ObjectV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.ObjectV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.ObjectV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.ObjectV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.freeform.ObjectMetadataV2.serializeBinaryToWriter
    );
  }
  f = message.getSize();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.freeform.Size.serializeBinaryToWriter
    );
  }
  f = message.getTransform();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.freeform.AffineTransform.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.freeform.TextContentV2.serializeBinaryToWriter
    );
  }
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.freeform.ImageContentV2.serializeBinaryToWriter
    );
  }
  f = message.getOldText();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      freeform_v1_pb.FFText.serializeBinaryToWriter
    );
  }
  f = message.getDeprecatedSenderTag();
  if (f) {
    writer.writeBool(
      101,
      f
    );
  }
};


/**
 * optional ObjectMetadataV2 metadata = 1;
 * @return {?proto.freeform.ObjectMetadataV2}
 */
proto.freeform.ObjectV2.prototype.getMetadata = function() {
  return /** @type{?proto.freeform.ObjectMetadataV2} */ (
    jspb.Message.getWrapperField(this, proto.freeform.ObjectMetadataV2, 1));
};


/**
 * @param {?proto.freeform.ObjectMetadataV2|undefined} value
 * @return {!proto.freeform.ObjectV2} returns this
*/
proto.freeform.ObjectV2.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.ObjectV2} returns this
 */
proto.freeform.ObjectV2.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.ObjectV2.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Size size = 2;
 * @return {?proto.freeform.Size}
 */
proto.freeform.ObjectV2.prototype.getSize = function() {
  return /** @type{?proto.freeform.Size} */ (
    jspb.Message.getWrapperField(this, proto.freeform.Size, 2));
};


/**
 * @param {?proto.freeform.Size|undefined} value
 * @return {!proto.freeform.ObjectV2} returns this
*/
proto.freeform.ObjectV2.prototype.setSize = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.ObjectV2} returns this
 */
proto.freeform.ObjectV2.prototype.clearSize = function() {
  return this.setSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.ObjectV2.prototype.hasSize = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AffineTransform transform = 3;
 * @return {?proto.freeform.AffineTransform}
 */
proto.freeform.ObjectV2.prototype.getTransform = function() {
  return /** @type{?proto.freeform.AffineTransform} */ (
    jspb.Message.getWrapperField(this, proto.freeform.AffineTransform, 3));
};


/**
 * @param {?proto.freeform.AffineTransform|undefined} value
 * @return {!proto.freeform.ObjectV2} returns this
*/
proto.freeform.ObjectV2.prototype.setTransform = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.ObjectV2} returns this
 */
proto.freeform.ObjectV2.prototype.clearTransform = function() {
  return this.setTransform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.ObjectV2.prototype.hasTransform = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TextContentV2 text = 4;
 * @return {?proto.freeform.TextContentV2}
 */
proto.freeform.ObjectV2.prototype.getText = function() {
  return /** @type{?proto.freeform.TextContentV2} */ (
    jspb.Message.getWrapperField(this, proto.freeform.TextContentV2, 4));
};


/**
 * @param {?proto.freeform.TextContentV2|undefined} value
 * @return {!proto.freeform.ObjectV2} returns this
*/
proto.freeform.ObjectV2.prototype.setText = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.freeform.ObjectV2.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.ObjectV2} returns this
 */
proto.freeform.ObjectV2.prototype.clearText = function() {
  return this.setText(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.ObjectV2.prototype.hasText = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ImageContentV2 image = 5;
 * @return {?proto.freeform.ImageContentV2}
 */
proto.freeform.ObjectV2.prototype.getImage = function() {
  return /** @type{?proto.freeform.ImageContentV2} */ (
    jspb.Message.getWrapperField(this, proto.freeform.ImageContentV2, 5));
};


/**
 * @param {?proto.freeform.ImageContentV2|undefined} value
 * @return {!proto.freeform.ObjectV2} returns this
*/
proto.freeform.ObjectV2.prototype.setImage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.freeform.ObjectV2.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.ObjectV2} returns this
 */
proto.freeform.ObjectV2.prototype.clearImage = function() {
  return this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.ObjectV2.prototype.hasImage = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional FFText old_text = 100;
 * @return {?proto.freeform.FFText}
 */
proto.freeform.ObjectV2.prototype.getOldText = function() {
  return /** @type{?proto.freeform.FFText} */ (
    jspb.Message.getWrapperField(this, freeform_v1_pb.FFText, 100));
};


/**
 * @param {?proto.freeform.FFText|undefined} value
 * @return {!proto.freeform.ObjectV2} returns this
*/
proto.freeform.ObjectV2.prototype.setOldText = function(value) {
  return jspb.Message.setOneofWrapperField(this, 100, proto.freeform.ObjectV2.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.ObjectV2} returns this
 */
proto.freeform.ObjectV2.prototype.clearOldText = function() {
  return this.setOldText(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.ObjectV2.prototype.hasOldText = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * optional bool deprecated_sender_tag = 101;
 * @return {boolean}
 */
proto.freeform.ObjectV2.prototype.getDeprecatedSenderTag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 101, false));
};


/**
 * @param {boolean} value
 * @return {!proto.freeform.ObjectV2} returns this
 */
proto.freeform.ObjectV2.prototype.setDeprecatedSenderTag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 101, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.Size.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.Size.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.Size} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.Size.toObject = function(includeInstance, msg) {
  var f, obj = {
    width: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    height: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.Size}
 */
proto.freeform.Size.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.Size;
  return proto.freeform.Size.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.Size} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.Size}
 */
proto.freeform.Size.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setWidth(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.Size.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.Size.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.Size} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.Size.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWidth();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional float width = 1;
 * @return {number}
 */
proto.freeform.Size.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.Size} returns this
 */
proto.freeform.Size.prototype.setWidth = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float height = 2;
 * @return {number}
 */
proto.freeform.Size.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.Size} returns this
 */
proto.freeform.Size.prototype.setHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.AffineTransform.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.AffineTransform.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.AffineTransform} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.AffineTransform.toObject = function(includeInstance, msg) {
  var f, obj = {
    a: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    b: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    c: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    d: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    tx: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    ty: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.AffineTransform}
 */
proto.freeform.AffineTransform.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.AffineTransform;
  return proto.freeform.AffineTransform.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.AffineTransform} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.AffineTransform}
 */
proto.freeform.AffineTransform.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setA(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setB(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setC(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setD(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTx(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.AffineTransform.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.AffineTransform.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.AffineTransform} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.AffineTransform.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getA();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getB();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getC();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getD();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getTx();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getTy();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional float a = 1;
 * @return {number}
 */
proto.freeform.AffineTransform.prototype.getA = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.AffineTransform} returns this
 */
proto.freeform.AffineTransform.prototype.setA = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float b = 2;
 * @return {number}
 */
proto.freeform.AffineTransform.prototype.getB = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.AffineTransform} returns this
 */
proto.freeform.AffineTransform.prototype.setB = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float c = 3;
 * @return {number}
 */
proto.freeform.AffineTransform.prototype.getC = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.AffineTransform} returns this
 */
proto.freeform.AffineTransform.prototype.setC = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float d = 4;
 * @return {number}
 */
proto.freeform.AffineTransform.prototype.getD = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.AffineTransform} returns this
 */
proto.freeform.AffineTransform.prototype.setD = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double tX = 5;
 * @return {number}
 */
proto.freeform.AffineTransform.prototype.getTx = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.AffineTransform} returns this
 */
proto.freeform.AffineTransform.prototype.setTx = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double tY = 6;
 * @return {number}
 */
proto.freeform.AffineTransform.prototype.getTy = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.AffineTransform} returns this
 */
proto.freeform.AffineTransform.prototype.setTy = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.ObjectMetadataV2.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.ObjectMetadataV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.ObjectMetadataV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.ObjectMetadataV2.toObject = function(includeInstance, msg) {
  var f, obj = {
    objectId: msg.getObjectId_asB64(),
    dedupeId: msg.getDedupeId_asB64(),
    chatId: msg.getChatId_asB64(),
    senderId: msg.getSenderId_asB64(),
    oldChatId: jspb.Message.getFieldWithDefault(msg, 100, 0),
    oldSenderId: jspb.Message.getFieldWithDefault(msg, 101, 0),
    type: jspb.Message.getFieldWithDefault(msg, 5, 0),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    isAutopositioned: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    isBackground: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.ObjectMetadataV2}
 */
proto.freeform.ObjectMetadataV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.ObjectMetadataV2;
  return proto.freeform.ObjectMetadataV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.ObjectMetadataV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.ObjectMetadataV2}
 */
proto.freeform.ObjectMetadataV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setObjectId(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setDedupeId(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setChatId(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSenderId(value);
      break;
    case 100:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOldChatId(value);
      break;
    case 101:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOldSenderId(value);
      break;
    case 5:
      var value = /** @type {!proto.freeform.ObjectType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAutopositioned(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBackground(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.ObjectMetadataV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.ObjectMetadataV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.ObjectMetadataV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.ObjectMetadataV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObjectId_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getDedupeId_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getChatId_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getSenderId_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = message.getOldChatId();
  if (f !== 0) {
    writer.writeUint64(
      100,
      f
    );
  }
  f = message.getOldSenderId();
  if (f !== 0) {
    writer.writeUint64(
      101,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsAutopositioned();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getIsBackground();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional bytes object_id = 1;
 * @return {!(string|Uint8Array)}
 */
proto.freeform.ObjectMetadataV2.prototype.getObjectId = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes object_id = 1;
 * This is a type-conversion wrapper around `getObjectId()`
 * @return {string}
 */
proto.freeform.ObjectMetadataV2.prototype.getObjectId_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getObjectId()));
};


/**
 * optional bytes object_id = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getObjectId()`
 * @return {!Uint8Array}
 */
proto.freeform.ObjectMetadataV2.prototype.getObjectId_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getObjectId()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.freeform.ObjectMetadataV2} returns this
 */
proto.freeform.ObjectMetadataV2.prototype.setObjectId = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bytes dedupe_id = 2;
 * @return {!(string|Uint8Array)}
 */
proto.freeform.ObjectMetadataV2.prototype.getDedupeId = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes dedupe_id = 2;
 * This is a type-conversion wrapper around `getDedupeId()`
 * @return {string}
 */
proto.freeform.ObjectMetadataV2.prototype.getDedupeId_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getDedupeId()));
};


/**
 * optional bytes dedupe_id = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDedupeId()`
 * @return {!Uint8Array}
 */
proto.freeform.ObjectMetadataV2.prototype.getDedupeId_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getDedupeId()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.freeform.ObjectMetadataV2} returns this
 */
proto.freeform.ObjectMetadataV2.prototype.setDedupeId = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional bytes chat_id = 3;
 * @return {!(string|Uint8Array)}
 */
proto.freeform.ObjectMetadataV2.prototype.getChatId = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes chat_id = 3;
 * This is a type-conversion wrapper around `getChatId()`
 * @return {string}
 */
proto.freeform.ObjectMetadataV2.prototype.getChatId_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getChatId()));
};


/**
 * optional bytes chat_id = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChatId()`
 * @return {!Uint8Array}
 */
proto.freeform.ObjectMetadataV2.prototype.getChatId_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getChatId()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.freeform.ObjectMetadataV2} returns this
 */
proto.freeform.ObjectMetadataV2.prototype.setChatId = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional bytes sender_id = 4;
 * @return {!(string|Uint8Array)}
 */
proto.freeform.ObjectMetadataV2.prototype.getSenderId = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes sender_id = 4;
 * This is a type-conversion wrapper around `getSenderId()`
 * @return {string}
 */
proto.freeform.ObjectMetadataV2.prototype.getSenderId_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSenderId()));
};


/**
 * optional bytes sender_id = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSenderId()`
 * @return {!Uint8Array}
 */
proto.freeform.ObjectMetadataV2.prototype.getSenderId_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSenderId()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.freeform.ObjectMetadataV2} returns this
 */
proto.freeform.ObjectMetadataV2.prototype.setSenderId = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};


/**
 * optional uint64 old_chat_id = 100;
 * @return {number}
 */
proto.freeform.ObjectMetadataV2.prototype.getOldChatId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 100, 0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.ObjectMetadataV2} returns this
 */
proto.freeform.ObjectMetadataV2.prototype.setOldChatId = function(value) {
  return jspb.Message.setProto3IntField(this, 100, value);
};


/**
 * optional uint64 old_sender_id = 101;
 * @return {number}
 */
proto.freeform.ObjectMetadataV2.prototype.getOldSenderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 101, 0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.ObjectMetadataV2} returns this
 */
proto.freeform.ObjectMetadataV2.prototype.setOldSenderId = function(value) {
  return jspb.Message.setProto3IntField(this, 101, value);
};


/**
 * optional ObjectType type = 5;
 * @return {!proto.freeform.ObjectType}
 */
proto.freeform.ObjectMetadataV2.prototype.getType = function() {
  return /** @type {!proto.freeform.ObjectType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.freeform.ObjectType} value
 * @return {!proto.freeform.ObjectMetadataV2} returns this
 */
proto.freeform.ObjectMetadataV2.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp created = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.freeform.ObjectMetadataV2.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.freeform.ObjectMetadataV2} returns this
*/
proto.freeform.ObjectMetadataV2.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.ObjectMetadataV2} returns this
 */
proto.freeform.ObjectMetadataV2.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.ObjectMetadataV2.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool is_autopositioned = 7;
 * @return {boolean}
 */
proto.freeform.ObjectMetadataV2.prototype.getIsAutopositioned = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.freeform.ObjectMetadataV2} returns this
 */
proto.freeform.ObjectMetadataV2.prototype.setIsAutopositioned = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool is_background = 8;
 * @return {boolean}
 */
proto.freeform.ObjectMetadataV2.prototype.getIsBackground = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.freeform.ObjectMetadataV2} returns this
 */
proto.freeform.ObjectMetadataV2.prototype.setIsBackground = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.ImageContentV2.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.ImageContentV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.ImageContentV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.ImageContentV2.toObject = function(includeInstance, msg) {
  var f, obj = {
    assetKey: msg.getAssetKey_asB64(),
    senderTag: (f = msg.getSenderTag()) && freeform_v1_pb.SenderTagV2.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.ImageContentV2}
 */
proto.freeform.ImageContentV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.ImageContentV2;
  return proto.freeform.ImageContentV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.ImageContentV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.ImageContentV2}
 */
proto.freeform.ImageContentV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setAssetKey(value);
      break;
    case 2:
      var value = new freeform_v1_pb.SenderTagV2;
      reader.readMessage(value,freeform_v1_pb.SenderTagV2.deserializeBinaryFromReader);
      msg.setSenderTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.ImageContentV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.ImageContentV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.ImageContentV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.ImageContentV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssetKey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getSenderTag();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      freeform_v1_pb.SenderTagV2.serializeBinaryToWriter
    );
  }
};


/**
 * optional bytes asset_key = 1;
 * @return {!(string|Uint8Array)}
 */
proto.freeform.ImageContentV2.prototype.getAssetKey = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes asset_key = 1;
 * This is a type-conversion wrapper around `getAssetKey()`
 * @return {string}
 */
proto.freeform.ImageContentV2.prototype.getAssetKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getAssetKey()));
};


/**
 * optional bytes asset_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAssetKey()`
 * @return {!Uint8Array}
 */
proto.freeform.ImageContentV2.prototype.getAssetKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getAssetKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.freeform.ImageContentV2} returns this
 */
proto.freeform.ImageContentV2.prototype.setAssetKey = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional SenderTagV2 sender_tag = 2;
 * @return {?proto.freeform.SenderTagV2}
 */
proto.freeform.ImageContentV2.prototype.getSenderTag = function() {
  return /** @type{?proto.freeform.SenderTagV2} */ (
    jspb.Message.getWrapperField(this, freeform_v1_pb.SenderTagV2, 2));
};


/**
 * @param {?proto.freeform.SenderTagV2|undefined} value
 * @return {!proto.freeform.ImageContentV2} returns this
*/
proto.freeform.ImageContentV2.prototype.setSenderTag = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.ImageContentV2} returns this
 */
proto.freeform.ImageContentV2.prototype.clearSenderTag = function() {
  return this.setSenderTag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.ImageContentV2.prototype.hasSenderTag = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.freeform.TextContentV2.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.TextContentV2.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.TextContentV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.TextContentV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.TextContentV2.toObject = function(includeInstance, msg) {
  var f, obj = {
    bubble: (f = msg.getBubble()) && proto.freeform.BubbleV2.toObject(includeInstance, f),
    senderTag: (f = msg.getSenderTag()) && freeform_v1_pb.SenderTagV2.toObject(includeInstance, f),
    runsList: jspb.Message.toObjectList(msg.getRunsList(),
    proto.freeform.TextRunV2.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.TextContentV2}
 */
proto.freeform.TextContentV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.TextContentV2;
  return proto.freeform.TextContentV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.TextContentV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.TextContentV2}
 */
proto.freeform.TextContentV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.freeform.BubbleV2;
      reader.readMessage(value,proto.freeform.BubbleV2.deserializeBinaryFromReader);
      msg.setBubble(value);
      break;
    case 2:
      var value = new freeform_v1_pb.SenderTagV2;
      reader.readMessage(value,freeform_v1_pb.SenderTagV2.deserializeBinaryFromReader);
      msg.setSenderTag(value);
      break;
    case 3:
      var value = new proto.freeform.TextRunV2;
      reader.readMessage(value,proto.freeform.TextRunV2.deserializeBinaryFromReader);
      msg.addRuns(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.TextContentV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.TextContentV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.TextContentV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.TextContentV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBubble();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.freeform.BubbleV2.serializeBinaryToWriter
    );
  }
  f = message.getSenderTag();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      freeform_v1_pb.SenderTagV2.serializeBinaryToWriter
    );
  }
  f = message.getRunsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.freeform.TextRunV2.serializeBinaryToWriter
    );
  }
};


/**
 * optional BubbleV2 bubble = 1;
 * @return {?proto.freeform.BubbleV2}
 */
proto.freeform.TextContentV2.prototype.getBubble = function() {
  return /** @type{?proto.freeform.BubbleV2} */ (
    jspb.Message.getWrapperField(this, proto.freeform.BubbleV2, 1));
};


/**
 * @param {?proto.freeform.BubbleV2|undefined} value
 * @return {!proto.freeform.TextContentV2} returns this
*/
proto.freeform.TextContentV2.prototype.setBubble = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.TextContentV2} returns this
 */
proto.freeform.TextContentV2.prototype.clearBubble = function() {
  return this.setBubble(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.TextContentV2.prototype.hasBubble = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SenderTagV2 sender_tag = 2;
 * @return {?proto.freeform.SenderTagV2}
 */
proto.freeform.TextContentV2.prototype.getSenderTag = function() {
  return /** @type{?proto.freeform.SenderTagV2} */ (
    jspb.Message.getWrapperField(this, freeform_v1_pb.SenderTagV2, 2));
};


/**
 * @param {?proto.freeform.SenderTagV2|undefined} value
 * @return {!proto.freeform.TextContentV2} returns this
*/
proto.freeform.TextContentV2.prototype.setSenderTag = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.TextContentV2} returns this
 */
proto.freeform.TextContentV2.prototype.clearSenderTag = function() {
  return this.setSenderTag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.TextContentV2.prototype.hasSenderTag = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated TextRunV2 runs = 3;
 * @return {!Array<!proto.freeform.TextRunV2>}
 */
proto.freeform.TextContentV2.prototype.getRunsList = function() {
  return /** @type{!Array<!proto.freeform.TextRunV2>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.freeform.TextRunV2, 3));
};


/**
 * @param {!Array<!proto.freeform.TextRunV2>} value
 * @return {!proto.freeform.TextContentV2} returns this
*/
proto.freeform.TextContentV2.prototype.setRunsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.freeform.TextRunV2=} opt_value
 * @param {number=} opt_index
 * @return {!proto.freeform.TextRunV2}
 */
proto.freeform.TextContentV2.prototype.addRuns = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.freeform.TextRunV2, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.freeform.TextContentV2} returns this
 */
proto.freeform.TextContentV2.prototype.clearRunsList = function() {
  return this.setRunsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.BubbleV2.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.BubbleV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.BubbleV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.BubbleV2.toObject = function(includeInstance, msg) {
  var f, obj = {
    color: (f = msg.getColor()) && proto.freeform.ColorV2.toObject(includeInstance, f),
    cornerRadius: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.BubbleV2}
 */
proto.freeform.BubbleV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.BubbleV2;
  return proto.freeform.BubbleV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.BubbleV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.BubbleV2}
 */
proto.freeform.BubbleV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.freeform.ColorV2;
      reader.readMessage(value,proto.freeform.ColorV2.deserializeBinaryFromReader);
      msg.setColor(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCornerRadius(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.BubbleV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.BubbleV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.BubbleV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.BubbleV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColor();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.freeform.ColorV2.serializeBinaryToWriter
    );
  }
  f = message.getCornerRadius();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional ColorV2 color = 1;
 * @return {?proto.freeform.ColorV2}
 */
proto.freeform.BubbleV2.prototype.getColor = function() {
  return /** @type{?proto.freeform.ColorV2} */ (
    jspb.Message.getWrapperField(this, proto.freeform.ColorV2, 1));
};


/**
 * @param {?proto.freeform.ColorV2|undefined} value
 * @return {!proto.freeform.BubbleV2} returns this
*/
proto.freeform.BubbleV2.prototype.setColor = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.BubbleV2} returns this
 */
proto.freeform.BubbleV2.prototype.clearColor = function() {
  return this.setColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.BubbleV2.prototype.hasColor = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float corner_radius = 2;
 * @return {number}
 */
proto.freeform.BubbleV2.prototype.getCornerRadius = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.BubbleV2} returns this
 */
proto.freeform.BubbleV2.prototype.setCornerRadius = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.TextRunV2.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.TextRunV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.TextRunV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.TextRunV2.toObject = function(includeInstance, msg) {
  var f, obj = {
    text: jspb.Message.getFieldWithDefault(msg, 1, ""),
    style: (f = msg.getStyle()) && proto.freeform.TextStyleV2.toObject(includeInstance, f),
    left: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    right: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    base: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.TextRunV2}
 */
proto.freeform.TextRunV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.TextRunV2;
  return proto.freeform.TextRunV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.TextRunV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.TextRunV2}
 */
proto.freeform.TextRunV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 2:
      var value = new proto.freeform.TextStyleV2;
      reader.readMessage(value,proto.freeform.TextStyleV2.deserializeBinaryFromReader);
      msg.setStyle(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setLeft(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRight(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBase(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.TextRunV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.TextRunV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.TextRunV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.TextRunV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStyle();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.freeform.TextStyleV2.serializeBinaryToWriter
    );
  }
  f = message.getLeft();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getRight();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getBase();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
};


/**
 * optional string text = 1;
 * @return {string}
 */
proto.freeform.TextRunV2.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.freeform.TextRunV2} returns this
 */
proto.freeform.TextRunV2.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TextStyleV2 style = 2;
 * @return {?proto.freeform.TextStyleV2}
 */
proto.freeform.TextRunV2.prototype.getStyle = function() {
  return /** @type{?proto.freeform.TextStyleV2} */ (
    jspb.Message.getWrapperField(this, proto.freeform.TextStyleV2, 2));
};


/**
 * @param {?proto.freeform.TextStyleV2|undefined} value
 * @return {!proto.freeform.TextRunV2} returns this
*/
proto.freeform.TextRunV2.prototype.setStyle = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.TextRunV2} returns this
 */
proto.freeform.TextRunV2.prototype.clearStyle = function() {
  return this.setStyle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.TextRunV2.prototype.hasStyle = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float left = 3;
 * @return {number}
 */
proto.freeform.TextRunV2.prototype.getLeft = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.TextRunV2} returns this
 */
proto.freeform.TextRunV2.prototype.setLeft = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float right = 4;
 * @return {number}
 */
proto.freeform.TextRunV2.prototype.getRight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.TextRunV2} returns this
 */
proto.freeform.TextRunV2.prototype.setRight = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float base = 5;
 * @return {number}
 */
proto.freeform.TextRunV2.prototype.getBase = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.TextRunV2} returns this
 */
proto.freeform.TextRunV2.prototype.setBase = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.TextStyleV2.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.TextStyleV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.TextStyleV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.TextStyleV2.toObject = function(includeInstance, msg) {
  var f, obj = {
    fontName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fontSize: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    color: (f = msg.getColor()) && proto.freeform.ColorV2.toObject(includeInstance, f),
    isUnderlined: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.TextStyleV2}
 */
proto.freeform.TextStyleV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.TextStyleV2;
  return proto.freeform.TextStyleV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.TextStyleV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.TextStyleV2}
 */
proto.freeform.TextStyleV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFontSize(value);
      break;
    case 3:
      var value = new proto.freeform.ColorV2;
      reader.readMessage(value,proto.freeform.ColorV2.deserializeBinaryFromReader);
      msg.setColor(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsUnderlined(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.TextStyleV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.TextStyleV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.TextStyleV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.TextStyleV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFontName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFontSize();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getColor();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.freeform.ColorV2.serializeBinaryToWriter
    );
  }
  f = message.getIsUnderlined();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string font_name = 1;
 * @return {string}
 */
proto.freeform.TextStyleV2.prototype.getFontName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.freeform.TextStyleV2} returns this
 */
proto.freeform.TextStyleV2.prototype.setFontName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional float font_size = 2;
 * @return {number}
 */
proto.freeform.TextStyleV2.prototype.getFontSize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.TextStyleV2} returns this
 */
proto.freeform.TextStyleV2.prototype.setFontSize = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional ColorV2 color = 3;
 * @return {?proto.freeform.ColorV2}
 */
proto.freeform.TextStyleV2.prototype.getColor = function() {
  return /** @type{?proto.freeform.ColorV2} */ (
    jspb.Message.getWrapperField(this, proto.freeform.ColorV2, 3));
};


/**
 * @param {?proto.freeform.ColorV2|undefined} value
 * @return {!proto.freeform.TextStyleV2} returns this
*/
proto.freeform.TextStyleV2.prototype.setColor = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.TextStyleV2} returns this
 */
proto.freeform.TextStyleV2.prototype.clearColor = function() {
  return this.setColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.TextStyleV2.prototype.hasColor = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool is_underlined = 4;
 * @return {boolean}
 */
proto.freeform.TextStyleV2.prototype.getIsUnderlined = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.freeform.TextStyleV2} returns this
 */
proto.freeform.TextStyleV2.prototype.setIsUnderlined = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.ColorV2.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.ColorV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.ColorV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.ColorV2.toObject = function(includeInstance, msg) {
  var f, obj = {
    red: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    green: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    blue: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    alpha: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.ColorV2}
 */
proto.freeform.ColorV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.ColorV2;
  return proto.freeform.ColorV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.ColorV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.ColorV2}
 */
proto.freeform.ColorV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRed(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGreen(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBlue(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAlpha(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.ColorV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.ColorV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.ColorV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.ColorV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRed();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getGreen();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getBlue();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getAlpha();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
};


/**
 * optional float red = 1;
 * @return {number}
 */
proto.freeform.ColorV2.prototype.getRed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.ColorV2} returns this
 */
proto.freeform.ColorV2.prototype.setRed = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float green = 2;
 * @return {number}
 */
proto.freeform.ColorV2.prototype.getGreen = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.ColorV2} returns this
 */
proto.freeform.ColorV2.prototype.setGreen = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float blue = 3;
 * @return {number}
 */
proto.freeform.ColorV2.prototype.getBlue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.ColorV2} returns this
 */
proto.freeform.ColorV2.prototype.setBlue = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float alpha = 4;
 * @return {number}
 */
proto.freeform.ColorV2.prototype.getAlpha = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.ColorV2} returns this
 */
proto.freeform.ColorV2.prototype.setAlpha = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * @enum {number}
 */
proto.freeform.ObjectType = {
  UNKNOWN: 0,
  PHOTO: 1,
  DRAWING: 2,
  VIDEO: 3,
  TEXT: 4,
  GIF: 5
};

goog.object.extend(exports, proto.freeform);
